import { AppAreaConfig } from '@/funnels/@types'
import female from './female'

const appAreaConfig: AppAreaConfig = {
	appArea: 'female-water-balance',
	landing: {
		ids: ['loader-water-balance-f'],
		route: {
			path: '/water-balance-f',
			name: 'female-water-balance-funnel',
		},
	},
	funnel: {
		id: 'ob-water-balance-female',
		route: {
			path: '/water-balance-f/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'water-balance-female-onboarding',
		},
		slug: 'female-water-balance',
		theme: 'light',
		locale: ['en'],
		redirectTo: {
			always: {
				appArea: female,
				page: 'lifestyle',
			},
		},
	},
}

export default appAreaConfig
